import { inject } from "@angular/core";
import { ResolveFn } from "@angular/router";
import { ClinicStore } from "../../store/clinic/clinic.store";

export const clinicDemographicsResolver: ResolveFn<any> = async () => {
    const clinicStore = inject(ClinicStore)
    try {
        await clinicStore.getDemographics()
    } catch(err) {
        console.error('Error fetching clinic demographics:', err);
    }
}